import { HttpEvent, HttpHandlerFn, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { inject } from '@angular/core';
import { engageAuthHeaders } from '../kiwixi/auth-headers';
import { AuthenticationService } from '../service/authentification.service';
import { SharedAppState } from '../store/app.states';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import * as authActions from '../store/actions/auth.actions';
import { ProfileStoreGuard } from '../guard/profileStore.guard';
import { isAiAccessRequest, isAiEngineUrl } from './ai-engine-request.util';

export const authProviderInterceptor = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
    let access_token: string;
    let xBundleRecurring: string;
    let isRefreshing = false;

    const authService = inject(AuthenticationService);
    const store = inject(Store<SharedAppState>);
    const router = inject(Router);
    const profileStoreGuard = inject(ProfileStoreGuard);

    store.select("auth").subscribe(state => {
        access_token = state.access_token;
        xBundleRecurring = state.xBundleRecurring;
    });

    function logout(): void {
        profileStoreGuard.resetUserDataLoaded();
        authService.logout();
        store.dispatch(authActions.logout());
        router.navigateByUrl('login');
    }

    function addAuthHeader(req: HttpRequest<any>): HttpRequest<any> {
        // Le moteur IA n'accepte que son propre jeton (lié au test) : l'identité Engage ne lui est pas envoyée.
        if (access_token && xBundleRecurring && !isAiEngineUrl(req.url)) {
            const bundle = JSON.parse(xBundleRecurring);
            return req.clone({
                setHeaders: engageAuthHeaders(bundle, access_token),
            });
        }
        return req;
    }

    function handleResponseError(error: any, req?: HttpRequest<any>, next?: HttpHandlerFn): Observable<HttpEvent<any>> {
        if (error.status === 401) {
            if (!isRefreshing) {
                isRefreshing = true;
                // Assuming a token refresh logic is needed, and a method like "refreshToken" exists
                // Uncomment and adjust the following lines based on your real refresh token logic.
                // return authService.signInUsingToken().pipe(
                //     switchMap(() => {
                //         isRefreshing = false;
                //         const newReq = addAuthHeader(req);
                //         return next(newReq).pipe(
                //             catchError((error) => {
                //                 logout();
                //                 return throwError(() => new Error(error));
                //             }),
                //         );
                //     }),
                //     catchError((error) => {
                //         logout();
                //         return throwError(() => new Error(error));
                //     }));
            }
        } else if (error.status === 403 && !isAiAccessRequest(req?.url)) {
            // Le refus d'un jeton du moteur IA n'est pas une fin de session Engage.
            logout();
        }
        return throwError(() => error);
    }

    return next(addAuthHeader(req)).pipe(
        catchError((error) => {
            return handleResponseError(error, req, next);
        })
    );
};
